'use client'
import useFormInitialStore from "@/store/form_initial";
import { ROUTE_HOME } from '@/navigation';
import { ReactElement, ReactNode, useEffect, useState } from "react";
import { DateTime } from 'luxon';
import { ConfigSlim, ConfigSlimStep } from "@/types/configuration";
// import logoAdvisory from '@/public/assets/loghi/advisory_orange.svg';
import useAnimatedRouter from "@/hooks/useAnimatedRouter";
import { createExecution } from "@/utils/client/client_api";
import useFormAdvisoryFullStore from "@/store/form_advisory_full";
import { isUserLogged } from "@/utils/account";
import WithoutAuthComponent from "./components/without_auth_component";
import WithAuthComponent from "./components/with_auth_component";
import { Logo } from "@/components/Logo"
import { version } from "os";

type Texts = {
    title1: string;
    title2: string;
    title3: string;

    text1: string;
    text2: string;
    loginTitle: ReactNode;
    registrationTitle: ReactNode;
    retrievePassword: string;
    emailLabel: string;
    passwordLabel: string;
    passwordConfirmLabel: string;
    privacy1: string;
    privacy2: string;
    termsOfUse1: string;
    termsOfUse2: string;
    cta: string;

    bTitle1: string;
    bTitle2: string;
    bSubtitle1: string;
    bText1: string;
    bSubtitle2: string;
    bText2: string;
    bSubtitle3: string;
    bText3: string;
    bSubtitle4: string;
    bText4: string;
    cTitle1: string;
    cTitle2: string;
    cSubtitle1: string;
    cText1: string;
    cSubtitle2: string;
    cText2: string;
    cSubtitle3: string;
    cText3: string;
    cCta: string;
    customerInfoText1: string;
    customerInfoText2: string;
    customerInfoText3: string;
}

type Props = {
    texts: any
    tenant: string,
    version: string
    locale: string
    configStep: ConfigSlimStep
    configInfo: ConfigSlim
    tenantMessageElement?: ReactElement
}
type ConsentItem = {
    consentCode: string;
    category: string;
    answerType: string;
    flagAccMandatory: boolean;
    flagMandatory: boolean;
    accepted: boolean;
};

enum PageView {
    LOADING = 1,
    WITHOUT_LOGIN,
    WITH_LOGIN
}

const Client = ({ locale, tenant, version, texts, configStep, configInfo, tenantMessageElement }: Props) => {

    const [pageView, setPageView] = useState(PageView.LOADING)

    const { setLandedAt, reset: resetFormInitialStore } = useFormInitialStore();
    const { reset: resetFormAdvisoryFullStore } = useFormAdvisoryFullStore();

    const { animatedRoute } = useAnimatedRouter();

    useEffect(() => {
        window.scrollTo(0, 0);

        manageView();

        resetFormInitialStore();
        resetFormAdvisoryFullStore();

        setLandedAt(DateTime.now());
        createExecution({ tenant: tenant, version: version });
    }, []);

    const manageView = async () => {
        // in case of logged user, redirect to HOME
        const isLogged = await isUserLogged();
        if (isLogged) {
            animatedRoute(ROUTE_HOME)
        } else {
            if (!configInfo.hasLogin) {
                setPageView(PageView.WITHOUT_LOGIN)
            } else {
                setPageView(PageView.WITH_LOGIN)
            }
        }
    }

    useEffect(() => {
        manageView()
    }, [configInfo])

    const renderPageContent = () => {
        switch (pageView) {
            case PageView.LOADING:
                return <div className="h-full flex flex-col justify-center">

                    <h1 className="mb-4 font-inter text-2xl font-semibold tracking-normal text-primaryBlue950">
                        {texts.title1} {texts.title2} {texts.title3}
                    </h1>
                    <div className="mb-6">
                        <Logo />
                    </div>
                </div>;
            case PageView.WITHOUT_LOGIN:
                return <WithoutAuthComponent
                    texts={texts}
                    locale={locale}
                    configInfo={configInfo}
                    configStep={configStep}
                    tenantMessageElement={tenantMessageElement}
                    goToAuthPath={() => setPageView(PageView.WITH_LOGIN)} />;
            case PageView.WITH_LOGIN:
                return <WithAuthComponent
                    texts={texts}
                    locale={locale}
                    configInfo={configInfo}
                    configStep={configStep}
                    tenantMessageElement={tenantMessageElement}
                    goToFreePath={() => setPageView(PageView.WITHOUT_LOGIN)} />;
        }
    };

    return (
        <div className="lg:h-full w-full">
            {renderPageContent()}
        </div>
    );
}

export default Client

